'use strict';

/* globals RELATIVE_PATH, document, $, bootbox */

require([RELATIVE_PATH + '/plugins/nodebb-plugin-surveys/static/vendor/vue.js'], function (Vue) {
	Vue.component('survey-completed', {
		props: ['initData', 'reset'],
		template:
		'<div class="text-center">' +
			'<strong>{{initData.translations.surveyEndMessage}}</strong><br />' +
			'<button class="btn btn-primary mt-2" v-on:click="reset()">{{initData.translations.correctAnswers}}</button>' +
		'</div>',
	});
});
